import React from "react"
import { useSnackbar } from "notistack"
import { RoboEnquetes } from "../../../services/apiRobo"
import { erroMsg } from "../components/comum"

/** Enquetes (porte da rail ☑️): lista, criação, resultados e envio. */
export function Enquetes() {
    const { enqueueSnackbar } = useSnackbar()
    const [itens, setItens] = React.useState<any[]>([])
    const [criando, setCriando] = React.useState(false)
    const [detalhe, setDetalhe] = React.useState<any>(null)
    const [carregando, setCarregando] = React.useState(false)

    const carregar = React.useCallback(async () => {
        setCarregando(true)
        try {
            setItens(await RoboEnquetes.listar())
        } catch (e) {
            enqueueSnackbar(erroMsg(e), { variant: "error" })
        } finally {
            setCarregando(false)
        }
    }, [enqueueSnackbar])

    React.useEffect(() => {
        carregar()
    }, [carregar])

    return (
        <section className="panel active" style={{ display: "block" }}>
            <div className="panel-actions">
                <button onClick={() => setCriando(true)}>➕ Nova enquete</button>
                <button className="ghost" onClick={carregar}>
                    ↻ Atualizar lista
                </button>
            </div>
            {carregando && <div className="muted small" style={{ padding: 12 }}>Carregando…</div>}
            {!carregando && (!itens || itens.length === 0) && <div className="empty">Nenhuma enquete.</div>}
            <ul className="list" style={{ listStyle: "none", margin: 0, padding: "0 12px 12px" }}>
                {(itens || []).map(e => (
                    <li
                        key={e.id}
                        style={{
                            background: "var(--panel)",
                            border: "1px solid var(--border)",
                            borderRadius: "var(--radius)",
                            padding: 12,
                            marginBottom: 8,
                        }}
                    >
                        <div style={{ fontWeight: 600 }}>{e.pergunta}</div>
                        <div className="muted small">
                            {e.status} · {opcoes(e.opcoes).length} opções
                        </div>
                        <div style={{ marginTop: 6, display: "flex", gap: 6 }}>
                            <button className="ghost" onClick={() => setDetalhe(e)}>
                                Resultados / enviar
                            </button>
                            <button
                                className="ghost warning"
                                onClick={async () => {
                                    try {
                                        await RoboEnquetes.remover(e.id)
                                        enqueueSnackbar("Removida.", { variant: "success" })
                                        carregar()
                                    } catch (err) {
                                        enqueueSnackbar(erroMsg(err), { variant: "error" })
                                    }
                                }}
                            >
                                🗑 Excluir
                            </button>
                        </div>
                    </li>
                ))}
            </ul>

            {criando && (
                <Criar
                    aoFechar={() => setCriando(false)}
                    aoCriar={() => {
                        setCriando(false)
                        carregar()
                    }}
                />
            )}
            {detalhe && <Detalhe enquete={detalhe} aoFechar={() => setDetalhe(null)} />}
        </section>
    )
}

function opcoes(v: any): string[] {
    if (Array.isArray(v)) return v
    try {
        const p = JSON.parse(v)
        return Array.isArray(p) ? p : []
    } catch {
        return []
    }
}

function Criar({ aoFechar, aoCriar }: { aoFechar: () => void; aoCriar: () => void }) {
    const { enqueueSnackbar } = useSnackbar()
    const [pergunta, setPergunta] = React.useState("")
    const [ops, setOps] = React.useState<string[]>(["", ""])

    async function salvar() {
        const limpas = ops.map(o => o.trim()).filter(Boolean)
        if (!pergunta.trim() || limpas.length < 2) {
            enqueueSnackbar("Pergunta e ao menos 2 opções.", { variant: "warning" })
            return
        }
        try {
            await RoboEnquetes.criar({ pergunta: pergunta.trim(), opcoes: limpas, formato: "AUTO" })
            enqueueSnackbar("Enquete criada (rascunho).", { variant: "success" })
            aoCriar()
        } catch (e) {
            enqueueSnackbar(erroMsg(e), { variant: "error" })
        }
    }

    return (
        <div className="modal" style={{ display: "flex" }}>
            <div className="modal-content" style={{ maxWidth: 520 }}>
                <div className="modal-header">
                    <strong>Nova enquete</strong>
                    <button className="ghost-icon-btn" onClick={aoFechar}>
                        ✕
                    </button>
                </div>
                <div className="modal-body">
                    <label>
                        Pergunta
                        <input type="text" value={pergunta} onChange={e => setPergunta(e.target.value)} style={{ width: "100%" }} />
                    </label>
                    {ops.map((o, i) => (
                        <div key={i} style={{ display: "flex", gap: 6, marginTop: 6 }}>
                            <input
                                type="text"
                                placeholder={"Opção " + (i + 1)}
                                value={o}
                                onChange={e => {
                                    const c = [...ops]
                                    c[i] = e.target.value
                                    setOps(c)
                                }}
                                style={{ flex: 1 }}
                            />
                            {ops.length > 2 && (
                                <button className="ghost" onClick={() => setOps(ops.filter((_, j) => j !== i))}>
                                    ✕
                                </button>
                            )}
                        </div>
                    ))}
                    <button className="ghost" style={{ marginTop: 6 }} onClick={() => setOps([...ops, ""])}>
                        ➕ Adicionar opção
                    </button>
                </div>
                <div className="modal-footer">
                    <button className="ghost" onClick={aoFechar}>
                        Cancelar
                    </button>
                    <button onClick={salvar}>Criar</button>
                </div>
            </div>
        </div>
    )
}

function Detalhe({ enquete, aoFechar }: { enquete: any; aoFechar: () => void }) {
    const { enqueueSnackbar } = useSnackbar()
    const [dados, setDados] = React.useState<any>(null)
    const [chatIds, setChatIds] = React.useState("")
    const [autos, setAutos] = React.useState<Record<number, any>>({})

    const carregar = React.useCallback(async () => {
        try {
            const d = await RoboEnquetes.detalhe(enquete.id)
            setDados(d)
            const map: Record<number, any> = {}
            for (const a of d?.autoRespostas || []) {
                map[a.indiceOpcao] = {
                    ativo: !!a.ativo,
                    texto: a.texto || "",
                    atrasoMin: a.atrasoMin ?? 3,
                    destino: a.destino || "DM",
                }
            }
            setAutos(map)
        } catch (e) {
            enqueueSnackbar(erroMsg(e), { variant: "error" })
        }
    }, [enquete.id, enqueueSnackbar])

    React.useEffect(() => {
        carregar()
    }, [carregar])

    function setAuto(i: number, campo: string, v: any) {
        setAutos(prev => ({ ...prev, [i]: { ...(prev[i] || { ativo: false, texto: "", atrasoMin: 3, destino: "DM" }), [campo]: v } }))
    }

    async function salvarAutos() {
        const lista = Object.keys(autos)
            .map(k => {
                const i = Number(k)
                const a = autos[i]
                return { indiceOpcao: i, ativo: !!a.ativo, texto: a.texto, atrasoMin: Number(a.atrasoMin) || 0, destino: a.destino }
            })
            .filter(a => a.ativo || (a.texto && a.texto.trim()))
        try {
            await RoboEnquetes.atualizarAutoRespostas(enquete.id, lista)
            enqueueSnackbar("Respostas automáticas salvas.", { variant: "success" })
            carregar()
        } catch (e) {
            enqueueSnackbar(erroMsg(e), { variant: "error" })
        }
    }

    async function enviar() {
        const ids = chatIds
            .split(/[,\s]+/)
            .map(s => Number(s.trim()))
            .filter(n => n > 0)
        if (ids.length === 0) {
            enqueueSnackbar("Informe ao menos um chatId.", { variant: "warning" })
            return
        }
        try {
            const r = await RoboEnquetes.enviar(enquete.id, ids)
            enqueueSnackbar("Enfileirados: " + (r?.enfileirados ?? 0), { variant: "success" })
            setChatIds("")
            carregar()
        } catch (e) {
            enqueueSnackbar(erroMsg(e), { variant: "error" })
        }
    }

    const ops = opcoes(enquete.opcoes)
    const votos = dados?.votosPorOpcao || {}
    const total = dados?.totalVotos || 0

    return (
        <div className="modal" style={{ display: "flex" }}>
            <div className="modal-content" style={{ maxWidth: 520 }}>
                <div className="modal-header">
                    <strong>{enquete.pergunta}</strong>
                    <button className="ghost-icon-btn" onClick={aoFechar}>
                        ✕
                    </button>
                </div>
                <div className="modal-body">
                    <div className="small muted" style={{ marginBottom: 6 }}>
                        Resultados ({total} votos)
                    </div>
                    {ops.map((o, i) => {
                        const n = Number(votos[i] || 0)
                        const pct = total > 0 ? Math.round((n / total) * 100) : 0
                        return (
                            <div key={i} style={{ marginBottom: 6 }}>
                                <div style={{ display: "flex", justifyContent: "space-between" }}>
                                    <span className="small">{o}</span>
                                    <span className="muted small">
                                        {n} ({pct}%)
                                    </span>
                                </div>
                                <div style={{ background: "var(--border)", borderRadius: 4, height: 8 }}>
                                    <div style={{ width: pct + "%", background: "var(--primary)", height: 8, borderRadius: 4 }} />
                                </div>
                            </div>
                        )
                    })}
                    <div className="small muted" style={{ marginTop: 14, marginBottom: 4 }}>
                        Respostas automáticas por alternativa
                    </div>
                    {ops.map((o, i) => {
                        const a = autos[i] || { ativo: false, texto: "", atrasoMin: 3, destino: "DM" }
                        return (
                            <div key={i} style={{ border: "1px solid var(--border)", borderRadius: 6, padding: 8, marginBottom: 6 }}>
                                <label className="small" style={{ display: "flex", alignItems: "center", gap: 6 }}>
                                    <input type="checkbox" checked={a.ativo} onChange={e => setAuto(i, "ativo", e.target.checked)} />
                                    <strong>{o}</strong>
                                </label>
                                {a.ativo && (
                                    <div style={{ marginTop: 6 }}>
                                        <textarea
                                            rows={2}
                                            placeholder="Mensagem automática quem votar nesta opção recebe…"
                                            value={a.texto}
                                            onChange={e => setAuto(i, "texto", e.target.value)}
                                            style={{ width: "100%" }}
                                        />
                                        <div style={{ display: "flex", gap: 8, alignItems: "center", marginTop: 4 }}>
                                            <label className="small muted">
                                                Atraso (min):
                                                <input
                                                    type="number"
                                                    min={0}
                                                    value={a.atrasoMin}
                                                    onChange={e => setAuto(i, "atrasoMin", e.target.value)}
                                                    style={{ width: 70, marginLeft: 4 }}
                                                />
                                            </label>
                                            <label className="small muted">
                                                Destino:
                                                <select value={a.destino} onChange={e => setAuto(i, "destino", e.target.value)} style={{ marginLeft: 4 }}>
                                                    <option value="DM">DM ao votante</option>
                                                    <option value="GRUPO">No grupo</option>
                                                </select>
                                            </label>
                                        </div>
                                    </div>
                                )}
                            </div>
                        )
                    })}
                    <button className="ghost" onClick={salvarAutos}>
                        💾 Salvar respostas automáticas
                    </button>

                    <div className="small muted" style={{ marginTop: 14, marginBottom: 4 }}>
                        Enviar / reenviar para chats (IDs separados por vírgula). Chats que já receberam são ignorados.
                    </div>
                    <div style={{ display: "flex", gap: 6 }}>
                        <input
                            type="text"
                            placeholder="ex.: 12, 34"
                            value={chatIds}
                            onChange={e => setChatIds(e.target.value)}
                            style={{ flex: 1 }}
                        />
                        <button onClick={enviar}>Enviar</button>
                    </div>
                </div>
                <div className="modal-footer">
                    <button className="ghost" onClick={aoFechar}>
                        Fechar
                    </button>
                </div>
            </div>
        </div>
    )
}

export default Enquetes
